package com.patronat.top.ui.organisms.user

import com.patronat.top.ui.molecules.UiStatusItem

data class UserFormData(
    val avatarUrl: Any? = null,
    val firstName: String = "",
    val lastName: String = "",
    val email: String = "",
    val phone: String = "",
    val statusItem: UiStatusItem<*>,
    val isLoading: Boolean = false
) {
    val initials: String
        get() {
            val f = firstName.firstOrNull()?.toString() ?: ""
            val l = lastName.firstOrNull()?.toString() ?: ""
            return if (f.isEmpty() && l.isEmpty()) "U" else "$f$l"
        }

    val isValid: Boolean
        get() = firstName.isNotBlank() && lastName.isNotBlank() && email.isNotBlank() && phone.isNotBlank()
}